import { render, staticRenderFns } from "./Components3.vue?vue&type=template&id=4d54d27c&scoped=true"
import script from "./Components3.vue?vue&type=script&lang=js"
export * from "./Components3.vue?vue&type=script&lang=js"
import style0 from "./Components3.vue?vue&type=style&index=0&id=4d54d27c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d54d27c",
  null
  
)

export default component.exports